// Static site configuration for Bombay Bespoke Fashion House

export const BRAND = {
  name: 'Bombay Bespoke Fashion House',
  shortName: 'Bombay Bespoke',
  womens: 'VM by Vandana',
  mens: 'Bombay Bespoke',
  tagline: 'Bespoke Tailoring & Couture, Dubai',
  legalName: 'Bombay Bespoke Fashion House LLC',
};

export const CONTACT = {
  phone: '+971 54 279 1122',
  phoneRaw: '+971542791122',
  whatsappNumber: '971542791122',
  email: 'info@bombaybespokefashion.com',
  addressLine1: 'Arif and Bintoak Building, Ground Floor, Shop 8',
  addressLine2: 'Al Karama, Dubai, United Arab Emirates',
  addressShort: 'Arif & Bintoak Building, Shop 8, Al Karama, Dubai',
  hours: 'Mon – Sat · 10:00 – 21:00',
  hoursSunday: 'Sunday · 16:00 – 21:30',
  mapsQuery: 'Bombay Bespoke Fashion House LLC Al Karama Dubai',
  mapsEmbed:
    'https://www.google.com/maps?cid=10617305285746562930&output=embed',
  mapsLink:
    'https://www.google.com/maps?cid=10617305285746562930',
};

export const SOCIAL = {
  instagram: 'https://www.instagram.com/vmandbb/',
  instagramHandle: '@vmandbb',
  tiktok: 'https://www.tiktok.com/@bombaybespokedubai',
  tiktokHandle: '@bombaybespokedubai',
};

export const WHATSAPP = {
  defaultMessage:
    "Hello Bombay Bespoke, I'd like to enquire about your bespoke services.",
  appointmentPrefill: (name = '') =>
    `Hello Bombay Bespoke, my name is ${name || '[Name]'}. I'd like to book a bespoke appointment.`,
};

export const buildWhatsappLink = (text) =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
    text || WHATSAPP.defaultMessage,
  )}`;

export const WOMENS_CATEGORIES = [
  {
    slug: 'lehengas',
    title: 'Lehengas',
    blurb: 'Heirloom silhouettes, hand-embroidered, made to order.',
    image: '/assets/w-bridal.jpg',
    available: true,
  },
  {
    slug: 'gowns',
    title: 'Gowns',
    blurb: 'Floor-sweeping silhouettes for the modern evening.',
    image: '/assets/w-gown.jpg',
    available: true,
  },
  {
    slug: 'resort-wear',
    title: 'Resort Wear',
    blurb: 'Soft tailoring for sun-soaked days.',
    image: '/assets/w-resort.jpg',
    available: true,
  },
  {
    slug: 'coord-sets',
    title: 'Coord Sets',
    blurb: 'Tailored separates, considered as a pair.',
    image: '/assets/w-pearl.jpg',
    available: true,
  },
  {
    slug: 'saris',
    title: 'Saris',
    blurb: 'Drape and detail — the eternal silhouette, reimagined.',
    image: '/assets/w-saree.jpg',
    available: true,
  },
  {
    slug: 'custom-design',
    title: 'Custom Design',
    blurb: 'A garment imagined entirely with you, for you.',
    image: '/assets/w-salwar.jpg',
    available: true,
  },
];

export const MENS_CATEGORIES = [
  {
    slug: 'shirts',
    title: 'Shirts',
    blurb: 'Cotton, linen, poplin — cut to the millimetre.',
    image: '/assets/m-shirt-new.jpg',
    available: true,
  },
  {
    slug: 'trousers',
    title: 'Trousers',
    blurb: 'A drape that flatters; a finish that lasts.',
    image: '/assets/m-trousers-beige.jpg',
    available: true,
  },
  {
    slug: 'sherwanis',
    title: 'Sherwanis',
    blurb: 'Ceremonial silhouettes, hand-embroidered for the occasion.',
    image: '/assets/m-sherwani.jpg',
    available: true,
  },
  {
    slug: 'kurta',
    title: 'Kurta',
    blurb: 'Traditional kurtas, tailored with intent.',
    image: '/assets/m-kurta.jpg',
    available: true,
  },
  {
    slug: 'suits',
    title: 'Suits',
    blurb: 'Two-piece, three-piece, tuxedo — entirely bespoke.',
    image: '/assets/m-suit-grey.jpg',
    available: true,
  },
];

export const PROCESS_STEPS = [
  {
    n: '01',
    title: 'Consultation',
    body:
      'A conversation about lifestyle, silhouette, and occasion. We listen first, then propose.',
  },
  {
    n: '02',
    title: 'Measurements',
    body:
      'Twenty-plus measurements taken by hand, recorded for every future garment.',
  },
  {
    n: '03',
    title: 'Design & Fabric',
    body:
      'Cloth from the world\u2019s finest mills, paired with sketches and references unique to you.',
  },
  {
    n: '04',
    title: 'Pattern & Cut',
    body:
      'Your individual pattern is drafted, then cut into a first-toile for fit and feel.',
  },
  {
    n: '05',
    title: 'Fittings',
    body:
      'Two to three fittings refine line and silhouette until the garment sits like a second skin.',
  },
  {
    n: '06',
    title: 'Final Garment',
    body:
      'Finishing by hand: buttonholes, edging, lining. Delivered, photographed, archived.',
  },
];
